import StimulusSortable from 'stimulus-sortable'

// Extends the base sortable controller to scroll the page while dragging.
// Without this, moving an item across a long list is awkward because items
// near the top/bottom can't be reached when the list doesn't fit on screen.
//
// We don't use SortableJS's built-in autoscroll: its top trigger zone sits at
// the very top of the window, which is hidden behind the fixed navbar, so
// scrolling up never kicks in. Instead we run our own scroll loop that keeps
// the top hot-zone below the navbar. `forceFallback` is required so the drag
// emits real pointer events (native HTML5 drag suppresses them).
export default class extends StimulusSortable {
  get defaultOptions() {
    return {
      forceFallback: true,
      scroll: true,
      bubbleScroll: true,
      scrollSensitivity: 200,
      scrollSpeed: 15,
    }
  }
}
